export default "__VITE_ASSET__b8e61e66__"